import { Component, Input } from '@angular/core';
import { SpotlightMenuSectionOverflowCalculatorComponentViewModel } from './spotlight-menu-section-overflow-calculator-component-view-model';
import { SpotlightMenu } from '../../../../../../models/menu/spotlight-menu';
import { MenuSectionOverflowCalculatorComponent } from '../../menu/menu-section-overflow-calculator/menu-section-overflow-calculator-component';

@Component({
  selector: 'app-spotlight-menu-section-overflow-calculator',
  templateUrl: './spotlight-menu-section-overflow-calculator.component.html',
  styleUrls: ['./spotlight-menu-section-overflow-calculator.component.scss'],
  providers: [SpotlightMenuSectionOverflowCalculatorComponentViewModel],
  standalone: false
})
export class SpotlightMenuSectionOverflowCalculatorComponent extends MenuSectionOverflowCalculatorComponent {
  constructor(public viewModel: SpotlightMenuSectionOverflowCalculatorComponentViewModel) {
    super(viewModel);
  }

  @Input() public menu: SpotlightMenu = null;
}
